import React from "react";
import { useTranslation } from "react-i18next";
import { TextSection } from "../../components/expretise/TextSection";
import DomainesIntervention from "../../components/expretise/DomainesIntervention";
import SlideGenerale from "../../components/expretise/slideGenarale";
import SEO from "../../components/SEO";
import img from "../../assets/images/AI.png";
import text from "../../assets/images/text-IA.png";
import { CercleIcon } from "../../assets/icons/CercleIcon";
import { Parametre } from "../../assets/icons/Parametre";
import { CardIcon } from "../../assets/icons/CardIcon";

export const Intelligence = () => {
  const { t } = useTranslation();

  const cards = [
    {
      id: 1,
      icon: <CardIcon />,
      title: t("intelligence.cards.automation.title"),
      description: t("intelligence.cards.automation.description"),
      backContent: [
        t("intelligence.cards.automation.details.0"),
        t("intelligence.cards.automation.details.1"),
        t("intelligence.cards.automation.details.2"),
        t("intelligence.cards.automation.details.3"),
      ],
    },
    {
      id: 2,
      icon: <CercleIcon />,
      title: t("intelligence.cards.platforms.title"),
      description: t("intelligence.cards.platforms.description"),
      backContent: [
        t("intelligence.cards.platforms.details.0"),
        t("intelligence.cards.platforms.details.1"),
        t("intelligence.cards.platforms.details.2"),
        t("intelligence.cards.platforms.details.3"),
      ],
    },
    {
      id: 3,
      icon: <Parametre />,
      title: t("intelligence.cards.models.title"),
      description: t("intelligence.cards.models.description"),
      backContent: [
        t("intelligence.cards.models.details.0"),
        t("intelligence.cards.models.details.1"),
        t("intelligence.cards.models.details.2"),
        t("intelligence.cards.models.details.3"),
      ],
    },
    {
      id: 4,
      icon: <CardIcon />,
      title: t("intelligence.cards.rpa.title"),
      description: t("intelligence.cards.rpa.description"),
      backContent: [
        t("intelligence.cards.rpa.details.0"),
        t("intelligence.cards.rpa.details.1"),
        t("intelligence.cards.rpa.details.2"),
        t("intelligence.cards.rpa.details.3"),
      ],
    },
    {
      id: 5,
      icon: <Parametre />,
      title: t("intelligence.cards.optimisation.title"),
      description: t("intelligence.cards.optimisation.description"),
      backContent: [
        t("intelligence.cards.optimisation.details.0"),
        t("intelligence.cards.optimisation.details.1"),
        t("intelligence.cards.optimisation.details.2"),
      ],
    },
  ];

  return (
    <div>
      <SEO
        title="MSIT AI - Intelligence Artificielle et Automatisation"
        description="MSIT AI développe des solutions d'intelligence artificielle, d'automatisation et de machine learning pour transformer votre entreprise avec des technologies de pointe."
        keywords="intelligence artificielle, IA, machine learning, automatisation, MSIT AI, RPA"
        url="https://www.msit-conseil.fr/bu-msit-ai"
        breadcrumbs={[
          { name: "Accueil", url: "https://www.msit-conseil.fr/" },
          { name: "MSIT AI", url: "https://www.msit-conseil.fr/bu-msit-ai" }
        ]}
      />
      <SlideGenerale
        headerBg="bg-dark"
        bgColor="bg-primary"
        sectionClass="consulting-section"
        heightBg={"consulting-section-height"}
        bgImage={img}
        infos={[
          {
            label: t("intelligence.slide.infos.0.label"),
            value: t("intelligence.slide.infos.0.value"),
          },
          {
            label: t("intelligence.slide.infos.1.label"),
            value: t("intelligence.slide.infos.1.value"),
          },
          {
            label: t("intelligence.slide.infos.2.label"),
            value: t("intelligence.slide.infos.2.value"),
          },
        ]}
        title={t("intelligence.slide.title")}
        description={t("intelligence.slide.description")}
      />
      <TextSection image={text} />
      <DomainesIntervention cards={cards} />
    </div>
  );
};
